module.exports = __webpack_public_path__ + "static/media/lu_hasta200Banner.f51c61d3.jpg";